<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.contractList.title')"
          icon="ti-receipt">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card
          class="rounded-0"
          :title="contractWizardTitle">
          <contract-wizard @wizardChange="wizardChange"></contract-wizard>
        </b-card>
      </b-col>
    </b-row>

    <div v-if="!$route.params.id">
      <b-row
        v-for="category in contractCategories"
        v-if="getContractsByCategory(category.value).length > 0"
        :key="category.value"
        class="mt-4">
        <b-col>
          <ContractsCard
            :collapseId="category.value + 'Id'"
            :title="category.text"
            :items="getContractsByCategory(category.value)"
            :phView="true"
            @showDetails="onShowDetails">
          </ContractsCard>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import ContractsCard from '@/components/contracts/ContractsCard'
  import ContractWizard from '@/components/contracts/ContractWizard'
  import HeaderView from '@/components/common/HeaderView'

  export default {
    name: 'ContractList',
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$store.dispatch('fetchContractPartners')
          .then(() => (vm.$store.dispatch('fetchAddresses')))
          .then(() => (vm.$store.dispatch('fetchContactPersons')))
          .then(() => (vm.$store.dispatch('fetchContracts')))
          .then(() => {
            if (to.params && to.params.id) {
              vm.$store.dispatch('fetchContractById', {id: to.params.id})
                .catch(() => vm.showErrorMsg({
                  message: vm.$t('error.contractList.fetchContractById')
                }))
            } else {
              vm.$store.commit('setCurrentContract', {})
              vm.$store.commit('updateContractCategory', null)
              if (vm.$store.getters.contactPersons.length > 0) {
                vm.$store.commit('updateContactPerson', vm.$store.getters.contactPersons[0])
              }
            }
          }).catch(() => vm.showErrorMsg({
            message: vm.$t('error.contractList.fetchContracts')
          })
        )
      })
    },
    components: {
      ContractsCard,
      ContractWizard,
      HeaderView
    },
    computed: {
      contractCategories () {
        return this.$store.getters.contractCategories.map(category => {
          return {
            value: category,
            text: this.$t('enums.contractCategories.' + category)
          }
        })
      },
      contractWizardTitle () {
        const subMessage = this.$t('message.contractList.infoCard.step' + (this.wizardIndex + 1) + '.title') +
          ' ' + this.$t('message.contractList.infoCard.step' + (this.wizardIndex + 1) + '.message')
        const subTitle = '<span class="subtitle ml-2">' + subMessage + '</span>'
        if (this.currentContract.id && this.currentContract.id !== -1) {
          return this.$t('message.contractList.contractWizardTitle.edit') + subTitle
        } else {
          return this.$t('message.contractList.contractWizardTitle.create') + subTitle
        }
      },
      currentContract: {
        get () {
          return this.$store.getters.currentContract
        },
        set (contract) {
          this.$store.commit('setCurrentContract', contract)
        }
      }
    },
    data () {
      return {
        wizardIndex: 0
      }
    },
    methods: {
      wizardChange (next) {
        this.wizardIndex = next
      },
      getContractsByCategory (category) {
        return this.$store.getters.contracts.filter(contract => contract.contractCategory === category)
      },
      onShowDetails (item) {
        this.$router.push({name: 'EditContract', params: {id: item.id}})
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.params && to.params.id) {
          this.$store.dispatch('fetchContractPartners')
            .then(() => (this.$store.dispatch('fetchAddresses')))
            .then(() => (this.$store.dispatch('fetchContactPersons')))
            .then(() => (this.$store.dispatch('fetchContracts')))
            .then(() => (this.$store.dispatch('fetchContractById', {id: to.params.id})))
            .catch(() => {
              this.showErrorMsg({
                message: this.$t('error.contractList.fetchContractById')
              })
            })
        }
      }
    }
  }
</script>

<style scoped>
  .btn-address:focus {
    box-shadow: none;
  }

  .addressbox-selected {
    background-color: rgba(0, 0, 0, .08);
    border: 2px solid #ccc;
  }

  .btn-link {
    color: #6c757d;
    text-decoration: none;
  }

  .btn-link:hover {
    color: #21272d;
  }
</style>

<style>
  .subtitle {
    font-weight: normal;;
    font-size: 1rem;
    color: #99abb4;
  }
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractList.vue